import React, { useEffect } from 'react';
import { getUnsolved, doResolve } from './paymentsService';
import { LinearProgress } from 'material-ui/Progress';
import {
    Checkbox,
} from 'material-ui';

import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
} from 'material-ui/Table';
import { Button } from 'material-ui';
import { Grid } from 'material-ui';
import moment from 'moment';

import { DoRender } from '../Utils/shared';
import swal from 'sweetalert';
import i18n from '../../services/i18n.js';
import translate from 'react-i18next/dist/commonjs/translate';

function PaymentsTable(props) {

    const { t } = props;

    const [loading, setLoading] = React.useState(false);
    const [rows, setRows] = React.useState([]);

    const [pagination, setPagination] = React.useState({
        page: 1,
        rowsPerPage: 10,
    });


    const fetchData = () => {
        setLoading(true);
        try {
            (async function setData() {
                const rows = await getUnsolved();

                setRows(rows);
                setLoading(false);
            })();
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };

    useEffect(() => {
        fetchData();
    }, []);    

    const handleChangePage = (event, page) => {
        setPagination((prev) => ({ 
            ...prev,
            page
        }));
    };

    const handleChangeRowsPerPage = event => {
        setPagination((prev) => ({ 
            ...prev,
            rowsPerPage: event.target.value
        }));
    };    

    const onCheckboxChange = (merchantOperation, event) => {
        const newValue = event.target.checked;

        setRows((prev) => prev.map((row, i) => ({
            ...row,
            solved: row.merchantOperationId === merchantOperation ? newValue : row.solved,
        })));
    };

    const formatDate = (value) => {
        return moment(value).utc().format('DD/MM/YYYY');
    };

    const askConfirmation = async (payments = []) => {
        return swal({
            text: i18n.t('PENDING_PAYMENTS.CONFIRM_SOLVE', { count: payments.length || '' }),
            icon: 'warning',
            buttons: true,
        });
    };

    const onSave = async () => {
        const payments = rows.filter((payment) => payment.solved === true );        
        const confirm = await askConfirmation(payments);

        if (!confirm) {
            return;
        }
        try {
            setLoading(true);
            const response = await doResolve(payments);
            setLoading(false);
            fetchData();
            return response;
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };

    const { rowsPerPage, page } = pagination;

    const pageRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const cols = [
        t('PENDING_PAYMENTS.OLYMPIA_LOCALIZATOR'),
        t('PENDING_PAYMENTS.PAYMENT_LOCALIZATOR'),
        t('PENDING_PAYMENTS.AMOUNT'),
        t('PENDING_PAYMENTS.DATE'),
        t('PENDING_PAYMENTS.STATE'),
        t('PENDING_PAYMENTS.SOLVED'),
    ];

    return (
        <div>
            <DoRender if={loading}>
                <LinearProgress className="cmsProgressBar" />
            </DoRender>

            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        { cols.map(col => <TableCell key={col}>{ col }</TableCell>)}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {pageRows.map((row) => {
                        const locators = row.PaymentLocators && row.PaymentLocators.length ? row.PaymentLocators.map(p => p.olyLocator).join(', ') : '';

                        return (<TableRow key={row.merchantOperationId}>
                            <TableCell align="right">{locators}</TableCell>
                            <TableCell align="right">{row.merchantOperationId}</TableCell>
                            <TableCell align="right">{Number(row.totalAmount) / 100}</TableCell>
                            <TableCell align="right">{formatDate(row.creationDate)}</TableCell>
                            <TableCell align="right">{row.status === 'pending' ? t('PENDING_PAYMENTS.POSIBLE_PAY') : t('PENDING_PAYMENTS.PAYED')}</TableCell>
                            <TableCell align="right">
                                <Checkbox onChange={(event) => onCheckboxChange(row.merchantOperationId, event)} checked={row.solved === true} />
                            </TableCell>
                        </TableRow>);
                    })}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                            labelRowsPerPage={t('PENDING_PAYMENTS.SHOWING')}
                            labelDisplayedRows={({ from, to, count }) => `${from} - ${to} ${t('PENDING_PAYMENTS.OF')} ${count}`}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </TableRow>
                </TableFooter>
            </Table>

            <Grid style={{ margin: '12px' }} container direction="row" justify="center" alignItems="center">
                <Button variant="raised" color="primary" onClick={onSave}>{t('PENDING_PAYMENTS.SAVE_CHANGES')}</Button>
            </Grid>
        </div>
    );
}


export default translate('translations')(PaymentsTable);


// WEBPACK FOOTER //
// ./src/components/Payments/PaymentsTable.js